import React from 'react'
import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { GroupSVG } from '../Icons/Basic'
import { DefaultIcon, GravatarParent } from './styles'

const GroupBadge = styled.span`
  position: absolute;
  right: -4px;
  bottom: -4px;
  display: flex;
  border-radius: 50%;
  background: ${palette.neutral.white};
`

// A group's initials in the circle a user's avatar uses ("Security team" -> ST),
// badged with the group icon so it reads as a group.
export const GroupAvatar = ({ name }: { name: string }): JSX.Element => (
  <GravatarParent size={24} aria-hidden="true">
    <DefaultIcon size={24}>
      {name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0].toUpperCase())
        .join('')}
    </DefaultIcon>
    <GroupBadge>
      <GroupSVG width={14} height={14} />
    </GroupBadge>
  </GravatarParent>
)
